import React from "react";
import { bind } from "decko";

export default class ClipListMatchSelector extends React.Component {

    @bind
    setDate (ev) {
        ev.preventDefault();
        this.props.onChangeDate(ev.target.value);
    }

    @bind
    clearDate () {
        this.props.onChangeDate("");
    }

    @bind
    handleGameChange (e) {
        const value = e.target.value;
        const game = value === "" ? null : value;
        this.props.onChangeGame(game);
        e.preventDefault();
    }

    gameToString (game) {
        const home = game.home_team.name;
        const away = game.visiting_team.name;
        const d = new Date(game.start_time);
        const hours = d.getHours().toString(10).padStart(2, "0");
        const minutes = d.getMinutes().toString(10).padStart(2, "0");
        return `${hours}:${minutes}: ${home} v ${away}`;
    }

    render () {
        let games = this.props.games.map(g => (
            <option key={g.key} value={g.key}>{this.gameToString(g.game)}</option>
        ));
        games.unshift(<option key="all" value="">All matches</option>)

        return (
            <div className="row">
                <div className="form-inline form-group-sm clip-list-date-container">
                    <select id="clip-list-game-select" className="form-control" onChange={this.handleGameChange}>
                        {games}
                    </select>
                    <button
                        className={"form-control btn btn-" + (this.props.date ? "default" :"success")}
                        title="Reset date to today"
                        onClick={this.clearDate}>
                        Today
                    </button>
                    <input className="form-control"
                           type="date"
                           value={this.props.date}
                           onChange={this.setDate} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/ClipListMatchSelector.js